import { Component, OnInit } from '@angular/core';
import { ShoppingCartService } from '../shopping-cart/shopping-cart.service';
import { TokenService } from '../../services/token.service';

@Component({
  selector: 'app-cart-button',
  templateUrl: './cart-button.component.html',
  styleUrls: ['./cart-button.component.scss']
})
export class CartButtonComponent implements OnInit {
  cartItems = 0;
  cartOpen = false;
  inElement = false;

  constructor(
    private shoppingCart: ShoppingCartService,
    private tokenService: TokenService
  ) {}

  ngOnInit() {
    this.getCart();
  }

  getCart() {
    if (this.tokenService.getToken()) {
      this.shoppingCart.getCart(this.tokenService.getToken().email).subscribe(
        data => {
          console.log('cart data', data);
          this.calculateProductsInCart(data);
        },
        err => {
          console.log('cart err', err);
        }
      );
    } else {
      setTimeout(this.getCart, 3000);
    }
  }

  calculateProductsInCart(cart) {
    let total = 0;
    for (let i = 0; i < cart.length; i++) {
      for (let j = 0; j < cart[i].subCart.products.length; j++) {
        total += cart[i].subCart.products[j].cartDetails.amount;
      }
    }
    this.cartItems = total;
  }

  goToCart() {
    window.location.href = `https://www.supplyhub.com/home`;
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/cart-button/cart-button.component.ts